(ns frontend.view.modals.curtains.sales-opportunity.lost-curtain
  (:require
   [common.util :as cu]
   [common.localization :as loc]
   [common.entity :as entity]
   [common.schema.entities.pipeline :as pipeline]
   [ui.state.named-values :as named-values]
   [frontend.view.modals.curtains.opportunity-load :as opportunity-load]
   [frontend.view.modals.curtains.sales-opportunity.events :as events]
   [reagent.core :as r]
   [ui.editors.labelled-input.view :as labelled-input]
   [ui.components.modal.view :as modal]
   [ui.color :as c]))

(defonce modal-key :curtain.sales-opportunity/lost)

(defn lost-reason-selector
  [edit-state state-atom loss-reasons]
  (let [attribute :sales-opportunity/lost-reason
        field-schema {:field/attribute attribute
                      :attribute attribute
                      :field/data-type :data.type/ref-single
                      :value-type :entity
                      :field/entity-types [:entity.type/named-value]
                      :named-value-attribute :sales-opportunity/lost-reason ;; TODO @Pirinen loss-reason vs lost-reason
                      :create-on-fly? true
                      :field/default-authorization {:access/create :role/admin}
                      :mandatory-entity-fields [:named-value/value]
                      :field/not-clearable? true
                      :field/default-visibility {:editor :editor.type/select
                                                 :grid   :editor.type/select}
                      :editor/type :editor.type/select}
        value (get @edit-state attribute)
        options (->> loss-reasons
                     (map (fn [c]
                            {:value (:db/id c)
                             :label (entity/display-string c)})))]
    [:div
     [labelled-input/view
      {:editor-type :editor.type/select
       :mandatory? true
       :label (loc/tr :sales-opportunity-lost-curtain/record-why-rejected)
       :options options
       :value (->> options
                   (cu/filter-by :value value)
                   (first))
       :on-change (fn [new-value _selected-option]
                    (if (nil? new-value)
                      (swap! edit-state dissoc attribute)
                      (swap! edit-state assoc attribute new-value)))}]

    ;;  [field-editor/view
    ;;   (merge
    ;;    field-schema
    ;;    {:drag-options       {:hide-drag-area? true}
    ;;     :state-atom         state-atom
    ;;     :class-name         (fu/cs (:class-name field-schema))
    ;;     ;;:mandatory? true
    ;;     :value              value
    ;;     :label              (loc/tr :sales-opportunity-lost-curtain/record-why-rejected)
    ;;     :read-only?         false
    ;;     :menu-portal-target (.getElementById js/document "react-select-menu-container")
    ;;     :options            (->> loss-reasons
    ;;                              (map (fn [c]
    ;;                                     {:key   (:db/id c)
    ;;                                      :label (entity/display-string c)})))
    ;;     :placeholder        (loc/tr :loss-reason-placeholder)
    ;;     ;;:tools [:tool-item/cancel]
    ;;     :on-save!           (fn [attribute new-value on-success! on-error!]
    ;;                           (if (nil? new-value)
    ;;                             (swap! edit-state dissoc attribute)
    ;;                             (let [loss-reason-entity (get @session/entities new-value)]
    ;;                               (swap! edit-state assoc attribute new-value)))
    ;;                           (on-success!))
    ;;    })]
     ]))

(defn internal-comment-input
  [edit-state state-atom sales-opportunity]
  (let [attribute :internal-comment
        field-schema {:field/attribute attribute
                      :attribute       attribute
                      :field/data-type :data.type/text
                      :field/default-visibility {:editor :editor.type/text-simple
                                                 :grid   :editor.type/text-simple}
                      :editor/type     :editor.type/text-simple}
        value (get @edit-state attribute)]
    [:div
     [labelled-input/view
      {:label (loc/tr :sales-opportunity-lost-curtain/internal-loss-comment)
       :data-type :data.type/text-multiline
       :value value
       :on-change (fn [new-value]
                    (if (nil? new-value)
                      (swap! edit-state dissoc attribute new-value)
                      (swap! edit-state assoc attribute new-value)))}]]))

(defn loaded-view
  "The curtain, for an opportunity that is loaded. The opportunity is
   `:opportunity` in the arguments."
  [{:keys [_shown? _topmost? _close-modal! _props state _class-name _opportunity]}]
  (let [edit-state (r/cursor state [:edit])
        state-atom (r/cursor state [:state-atom])]
    (fn [{:keys [shown? topmost? close-modal! props state _class-name opportunity]}]
      (let [{:keys [reset-focus!]} props
            sales-opportunity opportunity
            pipeline-id (pipeline/containing-pipeline-id sales-opportunity)
            sales-opportunity-name (:sales-opportunity/name sales-opportunity)
            header-text (loc/tr :sales-opportunity-loss-curtain/title [sales-opportunity-name])
            close-modal! (fn []
                           (close-modal!)
                           (when reset-focus!
                             (reset-focus!)))

            ;; Without the pipeline, a reason that is archived in it is offered.
            loss-reasons (->> (named-values/usable-rows :sales-opportunity/lost-reason pipeline-id)
                              (sort-by :common/ord))

            ;; Seed the first reason as the default here rather than once when the
            ;; curtain mounts: these options are named-values, which on the new
            ;; grid arrive from the search index a moment later, so a mount-time
            ;; default read nothing and left the form unsubmittable. Guarded on
            ;; the value being unset, so it runs once and cannot re-render loop.
            _ (when (and (seq loss-reasons)
                         (nil? (get @edit-state :sales-opportunity/lost-reason)))
                (swap! edit-state assoc :sales-opportunity/lost-reason (:db/id (first loss-reasons))))

            edit-vals @edit-state
            ;; Resolved out of `loss-reasons`, not @session/entities: an
            ;; index-sourced named-value is never in the session cache, which
            ;; left this nil and the submit button permanently disabled.
            loss-reason-entity (let [id (:sales-opportunity/lost-reason edit-vals)]
                                 (->> loss-reasons
                                      (filter (fn [nv] (= (:db/id nv) id)))
                                      first))
            button-disabled? (or (nil? loss-reason-entity)
                                 (:common/disabled? loss-reason-entity))

            error-text (when button-disabled?
                         (loc/tr :sales-opportunity-loss-curtain/select-loss-reason))

            reject! (fn []
                      (events/confirm-loss state sales-opportunity close-modal!))

            processing? (:processing @state)]
        [modal/view
         {:visible?      (and shown? topmost?)
          :hide!         close-modal!
          :backdrop      "static"
          :color         ::c/danger
          :close-button? true}
         [:<> [:i.fal.fa-ban.mr-2]
          header-text]
         [:<>
          [:div
           {:class "flex flex-col gap-4"}
           [lost-reason-selector edit-state state-atom loss-reasons]
           [internal-comment-input edit-state state-atom sales-opportunity]]]
         [:<>
          [modal/left-cancel-only close-modal! nil]
          [modal/right-single-button
           ::c/danger
           button-disabled?
           #(reject!)
           (loc/tr :sales-opportunity-loss-curtain/save)
           nil]]]))))

(defn view
  [{:keys [props] :as args}]
  [opportunity-load/with-opportunity
   {:opportunity-id (:sales-opportunity-id props)
    :args           args
    :loaded-view    loaded-view
    :header-text    [:<> [:i.fal.fa-ban.mr-2]
                     (loc/tr :sales-opportunity-loss-curtain/title [nil])]}])
